import React from "react";
import { Route, Routes } from "react-router-dom";

import { Page } from "lib/page";

import { RolesIndex } from "../roles";

import { EditSettingsPage } from "./editSettings";

export const SettingsIndex: React.FC = () => {
  return (
    <Routes>
      <Route path="roles/*" element={<Page element={<RolesIndex />} />} />
      <Route path="*" element={<Page element={<EditSettingsPage />} />} />
    </Routes>
  );
};
